// extracted by mini-css-extract-plugin
export var resourceContainer = "ResourceCard-module--resourceContainer--1ki6y";
export var resourceLink = "ResourceCard-module--resourceLink--2fXjL";
export var resourceTitle = "ResourceCard-module--resourceTitle--1w692";
export var resourceSubTitle = "ResourceCard-module--resourceSubTitle--1IX3d";
export var resourceLinkType = "ResourceCard-module--resourceLinkType--S7gFT";